module.exports = __webpack_public_path__ + "static/img/H4_1.8f73d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H4_1.png
// module id = lHLA
// module chunks = 0